import { VendorEnvironmentEnum } from './constants';

interface VendorType {
  vendorType: VendorEnvironmentEnum;
}

/**
 * Check if a vendor is a production vendor (PROD or CUSTOMER_TEST)
 */
export const isProductionVendor = (vendor: VendorType): boolean =>
  [VendorEnvironmentEnum.PROD, VendorEnvironmentEnum.CUSTOMER_TEST].includes(
    vendor.vendorType,
  );

/**
 * Check if a vendor is a sandbox vendor (SANDBOX, DEMO, DEV, INTERNAL_TEST)
 */
export const isSandboxVendor = (vendor: VendorType): boolean =>
  [
    VendorEnvironmentEnum.SANDBOX,
    VendorEnvironmentEnum.DEMO,
    VendorEnvironmentEnum.DEV,
    VendorEnvironmentEnum.INTERNAL_TEST,
  ].includes(vendor.vendorType);
